import React, { useMemo } from 'react';

import { ID_KINO_FREISTADT } from '@cineamo/api/constants/cinema-ids';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

const SVGTriangle = () => {
    return (
        <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 15V0L7.5 7.5L0 15Z"
                fill="white"
            />
        </svg>
    );
};

type SectionTitleProps = {
    title: string;
};

const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => {
    const domainConfiguration = useDomainConfiguration();
    const showTriangle = useMemo(() => domainConfiguration?.cinema?.id === ID_KINO_FREISTADT, [domainConfiguration]);
    return (
        <div className="flex flex-row items-center space-x-[6px]">
            {showTriangle && <SVGTriangle />}
            <h2 className="text-body-bold-16 lg:text-headline-18 text-overline-16-custom-style">{title}</h2>
        </div>
    );
};

export default SectionTitle;
